import React from 'react'
import { Navigate } from 'react-router-dom'
import LoadingScreen from '../SplashScreen'
import { useAuth } from '../../context/AuthContext'

type Props = {
  children: React.ReactNode
}

export default function PublicRoute({ children }: Props) {
  const { signed, loading } = useAuth()

  if (loading) return <LoadingScreen />

  if (signed) {
    return <Navigate to='/dashboard' replace />
  }

  return <>{children}</>
}
